module.exports = __webpack_public_path__ + "img/icons8-delete.050fb09a.svg";